export class WorkflowMoreCondition {
  id: number;
  workflowId: number;
  checkedMinReviewToFinalize: boolean;
  checkedMinSignerToFinalize: boolean;
  minReviewToFinalize: number;
  minSignerToFinalize: number;
  checkedNotifyAttachToReviewers: boolean;
  uploadDocument2Workflow?: boolean;
  checkedGetExternalDocument?: boolean;
  checkedCertifyDocument?: boolean;
  receiveDocumentFromFinishedWorkflow?: boolean;
  sequentialNumber?: boolean;
  upload2WorkflowId?: number;
  passwordWorkflow?: string;
  sequentialNumberWorkflow?: string;
  password2Upload?: string;
  checkedAddTraceability?: boolean;
  checkedAddManifest?: boolean;
  checkedPreventDuplicateSubject?: boolean;
}
